module.exports = __webpack_public_path__ + "img/qrcode.a495f0f5.png";